const isPublicPage = (path, publicRoutes) => publicRoutes.some(route => {
  // Convert dynamic route patterns (e.g., '/user/:id') to a regex
  const dynamicPattern = new RegExp(`^${route.replace(/:\w+/g, '[^/]+')}$`);
  return dynamicPattern.test(path);
});

export default isPublicPage;
